import { makeStyles } from '../../../../../../styles';
export default makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 'none',
        border: `1px solid ${theme.colors.gray[200]}`,
        borderRadius: theme.spacing(1),
        flex: 1,
        height: 435,
    },
    header: {
        background: theme.colors.gray[0],
        display: 'flex',
        padding: theme.spacing(2),
        alignItems: 'center',
        borderBottom: `1px solid ${theme.colors.gray[200]}`,
    },
    content: {
        padding: theme.spacing(1),
        height: '100%',
        overflowY: 'auto',
    },
    draggableConsumer: {
        marginBottom: theme.spacing(1),
    },
    addItem: Object.assign(Object.assign({}, theme.typography.body2), { background: theme.colors.primary.contrastWhite, color: theme.colors.primary.main, border: `2px solid ${theme.colors.primary.main}`, borderRadius: theme.spacing(1), marginBottom: theme.spacing(1), padding: theme.spacing(1, 1.5), cursor: 'pointer', width: '50%' }),
    icon: {
        color: theme.colors.primary.main,
        fontSize: theme.spacing(2.5),
        marginRight: theme.spacing(0.5),
    },
}));
//# sourceMappingURL=SelectedMetricsCard.styles.js.map